import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type CompaniesInProjectCustomDateRange = { from: string; to: string };

export const definedDateRangeTypes = [
  'thisMonth',
  'thisQuarter',
  'thisYear',
  'allProjects',
] as const;

type DefinedDateRangeType = (typeof definedDateRangeTypes)[number];

export type CompaniesInProjectDateRangeType =
  | DefinedDateRangeType
  | CompaniesInProjectCustomDateRange;

export const companiesInProjectSelectedDateRangeTypeState =
  atomWithStorage<CompaniesInProjectDateRangeType>(
    'companiesInProjectSelectedDateRangeTypeState',
    'allProjects',
  );

export type ChartType = 'funnel' | 'snapshot';

export const companiesInProjectActiveTabState = atom<ChartType>('snapshot');
